import React, { Component } from 'react';

//styles
import './SectionNine.scss';

import '../../static/fonts/opensanshebrew/stylesheet.css'
// import { fpInit } from '../../static/player'
import CountUpOnView from '../CountUpOnView/CountUpOnView';
import TrackVisibility from 'react-on-screen';

const AnimImages = ({ isVisible }) => {
    return (
        <div className={isVisible ? "anim-images active" : "anim-images"}>
            <div className="right-image"></div>
            <div className="left-image"></div>
        </div>)
}

class SectionNine extends Component {
    render() {
        return (
            <div id="section9" className="section9-container">
                <div className="desc-container">
                    <div className="title">גולשים באינטרנט</div>
                    <CountUpOnView start={0} end={36} prefix="כ-" suffix={"מיליון איראנים"} />
                    <div className="sub-title"><b>44.1%</b>מהאוכלוסייה</div>
                </div>
                <TrackVisibility partialVisibility once>
                    <AnimImages />
                </TrackVisibility>
            </div>
        );
    }
}

export default SectionNine;


// WEBPACK FOOTER //
// ./src/Components/SectionNine/SectionNine.js